// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as multiviewActionCreators from '../../actions/multiview';
import userActionCreators from '../../actions/user';
import deferComponentRender from '../../hocs/deferComponentRender';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';

import Multiview from './Multiview';
import selectMultiviewProps from './Multiview.selector';

const MultiviewContainer = () => {
  const { history, location } = useRouter();
  const { hash: locationHash } = location ?? {};

  const selectorProps = useMemo(() => ({ locationHash }), [locationHash]);
  const selectedProps = useSelector((state) => selectMultiviewProps(state, selectorProps));

  const handleCloseMatchList = useCallback(() => {
    history.goBackOrReplace(RoutesRedirectionFactory.getMultiviewRoutePathname());
  }, [history]);

  const otherProps = useMemo(
    () => ({
      handleCloseMatchList,
    }),
    [handleCloseMatchList],
  );

  const actions = useMemo(() => ({ ...multiviewActionCreators, ...userActionCreators }), []);

  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps, otherProps });

  return <Multiview {...enhancedProps} />;
};

export default deferComponentRender(MultiviewContainer);
